<mat-icon *ngIf="!src" [svgIcon]="typeIconName" [class.padding]="padding"></mat-icon>
<div class="cover" *ngIf="src" [style.background-image]="srcUrl"></div>
<div class="state-overlay" *ngIf="stateIconName">
  <mat-icon [svgIcon]="stateIconName"></mat-icon>
</div>



// WEBPACK FOOTER //
// ./src/app/material/material-image/material-image.component.html